import React from "react";
import Topheader from '../components/Topheader';

export default function TournamentRules() {
  return (
    <>
    <Topheader colorbox="newfaq_header_color" title="Reglas del Torneo" />
      <div className="container py-3">
          <ul style={{paddingLeft:"15px", fontWeight:"500"}}>
            <li>
              Los torneos comienzan a horas programadas y los asientos se
              asignan de forma aleatoria.
            </li>
            <li>
              El torneo termina cuando un jugador acumula todas
              las fichas del juego.
            </li>
            <li>
              Los jugadores que pierden todas sus fichas son eliminados
              del juego, a menos que se permitan reentradas o
              recompras.
            </li>
            <li>
              Si dos o más jugadores son eliminados en la misma
              mano, el jugador que comenzó la mano con más
              fichas terminará en una posición más alta.
            </li>
            <li>
              El Banco de Tiempo proporciona tiempo adicional de decisión
              que los jugadores pueden usar cuando sea necesario. El tiempo
              puede tomarse del banco hasta que se agote por completo.
            </li>
            <li>
              Todas las reglas estándar de torneo de póker aplican
              a los Torneos de Múltiples Mesas (MTTs).
            </li>
            <li>
              Los torneos otorgan fichas de juego gratuitas o Puntos de
              Recompensa como premios. No se distribuye dinero real
              en ninguna etapa.
            </li>
            <li>
              La App Store no tiene participación en la organización del torneo ni
              en la distribución de Puntos de Recompensa o fichas de juego gratuitas como
              premios.
            </li>
          </ul>
        </div>
    </>
  );
}
